<app-dialog [title]="data.title" [actions]="[{ text: 'Close'}]" (action)="action($event)" (close)="action($event)">
    <div class="body_modal_logistics">
        <form>
            <div class="row m-0">
                <div class="shipment_status-actions_value col-sm-6 px-0">
                    <span>Name</span>
                    <span class="gray_text">{{data?.details?.name }}</span>
                </div>
                <div class="shipment_status-actions_value col-sm-6 px-0">
                    <span>Host url</span>
                    <span class="gray_text">{{data?.details?.url }}</span>
                </div>
            </div>
        </form>
        <app-page-container-devider [title]="'Sync Settings'" [small]="true" class="mt-2"></app-page-container-devider>
            <div class="text-center my-5" *ngIf="!shipStationStore.length">
              <app-no-results *ngIf="!shipStationStore.length"  [message]="loader && !shipStationStore.length ? 'Loading Shipstation Stores ' : 'No Data found'"></app-no-results>
            </div>
            <div class="mt-4" *ngIf="shipStationStore.length">
              <div class="shipstation-row font-bold">
                <div>Sync</div>
                <div>Account Name</div>
                <div>Marketplace</div>
              </div>
              <div class="shipstation-row" *ngFor="let shipStation of shipStationStore; let i = index">
                <div>
                  <mat-slide-toggle
                    class="mat-slide-toggle-sm"
                    (change)="onCheckboxChange(shipStation)"
                    [(ngModel)]="shipStation.isSync">
                  </mat-slide-toggle>
                </div>
                <div>{{ shipStation.accountName }}</div>
                <div>{{ shipStation.marketplaceName }}</div>
              </div>
            </div>
    </div>
</app-dialog>